module.exports = __webpack_public_path__ + "img/2w.bb2fcaa0.svg";